import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import {
  createGranularRequestConfig,
  GranularCatalogConfig,
} from "@granular/fabric-catalog-helpers";
import {
  OperationEnrollmentListResponse,
  EnrollmentListResponse,
} from "../schemas";

const GET = async (
  params: {
    feature?: string;
    show_inactive?: boolean;
    date?: string;
  },
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig,
): Promise<AxiosResponse<OperationEnrollmentListResponse>> => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    searchParams.set(key, value.toString());
  });
  const queryParams = searchParams.toString();
  const url = `/api/enrollments-svc-lambda/enrollment${
    queryParams && "?" + queryParams
  }`;
  const response = await axios.get(
    url,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

/**
 * @deprecated Use GET using `enrollments-svc-lambda` instead
 */
const NON_LAMBDA_GET = async (
  params: {
    request_date?: string;
    values: string;
  },
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig,
): Promise<AxiosResponse<EnrollmentListResponse>> => {
  const requestDate = params.request_date || new Date().toISOString();
  const operationId =
    catalogConfig.getOperationId && catalogConfig.getOperationId();
  if (!operationId) {
    throw new Error("operationId is required");
  }
  const url = `/api/enrollments-svc/v3/enrollments?request_date=${requestDate}&operation_id=${operationId}&values=${params.values}`;
  const response = await axios.get(
    url,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};
/**
 * @deprecated Use `enrollments-svc-lambda` instead
 */
const nonLambda = {
  /**
   * @deprecated Use GET using `enrollments-svc-lambda` instead
   */
  GET: NON_LAMBDA_GET,
};

export default {
  GET,
  nonLambda,
};
